import { grabAccountCodes } from "../dataLayer/accountCode";
import { AccountCode } from "../interfaces/AccountCodeInterface";

class AccountCodeManager {

    async getAccountCodes(): Promise<AccountCode[]> {
        return await grabAccountCodes();
    }

}

export default new AccountCodeManager();
